<div class="panel outline">
  @for (outlineItem of meeting.outlineItems; track outlineItem.id) {
    <div class="outline-item clickable" [id]="'outline-item-' + outlineItem.id">
      <div class="header" (click)="toggleFold(outlineItem.id)">
        <div class="toggle">
          <mat-icon>{{ isItemOpen[outlineItem.id] ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
        </div>
        <div class="title">{{ outlineItem.title }}</div>
        <div class="timestamp-container">
          <div class="timestamp">
            {{ outlineItem.startTimeSeconds | timestamp }}
          </div>
        </div>
      </div>

      @if (isItemOpen[outlineItem.id]) {
        <div class="content-container" (click)="handleClickItemContent(outlineItem)">
          @for (section of sections; track section) {
            @if (section.type === 'TEXT') {
              <div class="section {{ section.fieldName }}">
                <div class="label-container">
                  <div class="label" [style.background-color]="section.color">{{ section.translationKey | translate }}</div>
                </div>
                <div class="content hoverable">
                  {{ outlineItem[section.fieldName] }}
                </div>
              </div>
            } @else if (section.type === 'ACTION_ITEMS' && outlineItem.actionItems.length > 0) {
              <div class="section {{ section.fieldName }}">
                <div class="label-container">
                  <div class="label" [style.background-color]="section.color">{{ section.translationKey | translate }}</div>
                </div>
                <div class="content">
                  @for (actionItem of outlineItem.actionItems; track actionItem.id) {
                    <div class="list-item">
                      <div class="dot">⋅</div>
                      <div class="value hoverable">
                        {{ formatActionItem(actionItem) }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else if (section.type === 'CHALLENGES' && outlineItem.challenges.length > 0) {
              <div class="section {{ section.fieldName }}">
                <div class="label-container">
                  <div class="label" [style.background-color]="section.color">{{ section.translationKey | translate }}</div>
                </div>
                <div class="content">
                  @for (challenge of outlineItem.challenges; track challenge.id) {
                    <div class="list-item">
                      <div class="dot">⋅</div>
                      <div class="value hoverable">
                        {{ formatChallenge(challenge) }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else if (section.type === 'TEXT_LIST' && $any(outlineItem[section.fieldName]).length > 0) {
              <div class="section {{ section.fieldName }}">
                <div class="label-container">
                  <div class="label" [style.background-color]="section.color">{{ section.translationKey | translate }}</div>
                </div>
                <div class="content">
                  @for (item of $any(outlineItem[section.fieldName]); track item) {
                    <div class="list-item">
                      <div class="dot">⋅</div>
                      <div class="value hoverable">{{ item }}</div>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  }
</div>
